import React from "react";

const highlightStyle = {
  color: "orange",
  fontWeight: "bold",
};

const PrivacyPolicy = () => {
  return (
    <div>
      <h2>Privacy Policy</h2>
      <p>
        At <span style={highlightStyle}>Hxabyte Records</span>, we are committed
        to protecting your privacy. This Privacy Policy explains how we collect,
        use, disclose, and safeguard your information when you use our platform
        including the website{" "}
        <a href="https://hxabyte.com/" style={highlightStyle}>
          https://hxabyte.com/
        </a>
        and our mobile application available on the Google Play Store
        (collectively referred to as the "
        <span style={highlightStyle}>Hxabyte</span>" app or "
        <span style={highlightStyle}>Hxabyte</span>" platform . This includes
        any other media form, media channel, mobile website, or mobile
        application related or connected thereto. Please read this privacy
        policy carefully. If you do not agree with the terms of this privacy
        policy, please do not access the platform.
      </p>

      <h2>Information We Collect</h2>
      <p>
        We collect personal information that you voluntarily provide to us when
        registering on the <span style={highlightStyle}>Hxabyte</span> platform,
        expressing interest in our services, participating in activities, or
        otherwise contacting us. The personal information that we collect
        depends on the context of your interactions with us and the{" "}
        <span style={highlightStyle}>Hxabyte</span> platform, the choices you
        make, and the features you use. This may include:
      </p>
      <ul>
        <li>
          Personal Information Provided by You: names, phone numbers, email
          addresses, usernames, passwords, contact preferences, billing
          addresses, debit/credit card numbers, and other similar information.
        </li>
      </ul>

      <h2>Use of Your Information</h2>
      <p>
        We use personal information collected via our{" "}
        <span style={highlightStyle}>Hxabyte</span> platform for the following
        purposes:
      </p>
      <ul>
        <li>To facilitate account creation and login process.</li>
        <li>To send administrative information and updates.</li>
        <li>To fulfill and manage your orders and purchases.</li>
        <li>To respond to user inquiries and support requests.</li>
        <li>To request feedback and conduct user research.</li>
        <li>
          To send you promotional and marketing communications, where legally
          permitted.
        </li>
        <li>To improve app functionality, performance, and security.</li>
        <li>
          To enforce our terms, conditions, and policies for legal and business
          purposes.
        </li>
      </ul>
    </div>
  );
};

export default PrivacyPolicy;
